import { Action } from '../../../core/common/action';
import { MarketingSeries } from '../common/market-series';
import { Attribute } from '../common/attribute';
import { Image } from '../../../core/common/image';
import * as Library from '../../../core/library/index';

export class FeatureConfig extends Action {
  public name = '';
  public displayName = '';
  public description = '';
  public active = false;

  /*
   * Constructor()
   */
  constructor();
  constructor(config: Object);
  constructor(config?: any) {
    super(config);
    this.name = Library.init(config, 'name');
    this.displayName = Library.init(config, 'displayName');
    this.description = Library.init(config, 'description');
    this.active = Library.init(config, 'active');
  }
}
